var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.pendantVisible)?_c('Pendant',{attrs:{"icon-url":_vm.iconUrl,"time":_vm.time,"segments":3,"show-tooltip":false},on:{"countdown-end":function($event){return _vm.$emit('end')},"click":_vm.showModal}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }